import {unexpectedCase} from 'nutshell-core/reducer-utils';
import type {LimitedType} from 'nutshell-graphql-types';

// @ts-expect-error
import {ActionTypes, LimitAction} from './limits-actions';

export type LimitsState = {
    type: LimitedType | null | undefined;
    isAllLimitsModalOpen: boolean;
    allLimitsModalShouldLinkToBilling: boolean;
    allLimitsModalTitleText?: string;
};

const defaultLimitsState = {
    type: null,
    isAllLimitsModalOpen: false,
    allLimitsModalShouldLinkToBilling: true,
} as const;

export const limitsReducer = (
    state: LimitsState | null | undefined = defaultLimitsState,
    action: LimitAction
): LimitsState => {
    switch (action.type) {
        case ActionTypes.LIMIT_MODAL_TOGGLED:
            // @ts-expect-error
            return {
                ...state,
                type: action.payload,
            };
        case ActionTypes.ALL_LIMITS_MODAL_TOGGLED:
            return {
                ...state,
                isAllLimitsModalOpen: action.payload.isAllLimitsModalOpen,
                // @ts-expect-error
                allLimitsModalShouldLinkToBilling: action.payload.allLimitsModalShouldLinkToBilling,
                allLimitsModalTitleText: action.payload.allLimitsModalTitleText,
            };
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
